import styled from 'styled-components'
import { Link } from 'react-router-dom'
import {
  mediumFont,
  primaryColor,
  primaryHoverColor,
  primaryActiveColor,
  whiteColor,
  whiteHoverColor,
  whiteActiveColor,
  secondaryHoverColor,
  secondaryActiveColor,
  secondaryColor,
  newsecondaryHoverColor,
  newsecondaryActiveColor,
  newsecondaryColor,
} from '@app/styles'

type LinkProps = {
  variant?: 'primary' | 'secondary' | 'white' | 'secondary' | 'newsecondary'
  fontSize?: string
}

export const AnchorLink = styled(Link)`
    cursor:pointer;
    text-decoration:none;
    ${mediumFont}
    ${({ fontSize = '0.9rem' }: LinkProps) => {
    return `font-size: ${fontSize};`
  }}
    
    ${({ variant }: LinkProps) => {
    if (variant === 'primary') {
      return `
                color: ${primaryColor};
                &:hover {
                    color: ${primaryHoverColor};
                }
                &:active {
                    color: ${primaryActiveColor};
                }
            `
    } else if (variant === 'white') {
      return `
                color: ${whiteColor};
                &:hover {
                    color: ${whiteHoverColor}
                }
                &:active{
                    color: ${whiteActiveColor}
                }
            `
    } else if (variant === 'secondary') {
      return `
                color: ${secondaryColor};
                &:hover {
                    color: ${secondaryHoverColor}
                }
                &:active{
                    color: ${secondaryActiveColor}
                }
            `
    } else if (variant === 'newsecondary') {
      return `
                color: ${newsecondaryColor};
                &:hover {
                    color: ${newsecondaryHoverColor}
                }
                &:active{
                    color: ${newsecondaryActiveColor}
                }
            `
    }
  }}
`
